/**
 * The scope picker's trigger, in its two shapes.
 *
 * The phone gets a tappable PILL rather than plain text with a caret: at that
 * size it has to read as a control, and it needs a real tap target. Anything
 * wider gets an eyebrow beside the title, as the design's `page-header.jsx`
 * has it.
 */
import { SCOPE_TRIGGER_PILL, SCOPE_TRIGGER_EYEBROW } from './scope-trigger-styles';

export interface ScopeTriggerProps {
  /** What the current scope is called. */
  label: string;
  open: boolean;
  onToggle: () => void;
  isPhone: boolean;
}

export function ScopeTrigger({ label, open, onToggle, isPhone }: ScopeTriggerProps) {
  return (
    <button
      type="button"
      data-testid="scope-trigger"
      onClick={onToggle}
      aria-expanded={open}
      aria-haspopup={isPhone ? 'dialog' : 'menu'}
      title="Change region"
      className={isPhone ? undefined : 'nb-eyebrow'}
      style={isPhone ? SCOPE_TRIGGER_PILL : SCOPE_TRIGGER_EYEBROW}
    >
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {label}
      </span>
      <svg
        width={isPhone ? 14 : 12}
        height={isPhone ? 14 : 12}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M6 9l6 6 6-6" />
      </svg>
    </button>
  );
}
